import { Table, TableapiApi } from '@datum-group/isogd-openapi/lib';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';

export class TableInfo {
  @observable private _table?: Table = undefined;
  @observable private _tableName: string;
  @observable private _isLoading = false;
  @observable private _error?: string = undefined;
  private _tableApi: TableapiApi;

  constructor(tableName: string, tableApi: TableapiApi) {
    this._tableApi = tableApi;
    this._tableName = tableName;
    makeObservable(this);
  }

  @computed get tableName() {
    return this._tableName;
  }

  @computed get description() {
    return this._table?.description;
  }

  @computed get display() {
    return this._table?.display;
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get error() {
    return this._error;
  }

  @computed get table() {
    return this._table ? { ...this._table } : undefined;
  }

  @action load = async () => {
    this._isLoading = true;
    this._error = undefined;

    try {
      const resp = await this._tableApi.apiTablesRead(this._tableName);
      runInAction(() => (this._table = resp.data));
    } catch (e) {
      runInAction(
        () =>
          (this._error = `Не удалось загрузить информацию о таблице с именем ${this._tableName}`),
      );
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  };
}
